module.exports = __webpack_public_path__ + "media/photo/AdobeStock_189545950-4b1e9f32.jpg";